import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import * as constants from '../_model/string_literal';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    const parsedToken = token ? JSON.parse(token) : null;
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': parsedToken?.token ? `Bearer ${parsedToken.token}` : ''
    });
  }

  get httpOptionsAuth() {
    return { headers: this.getAuthHeaders() };
  }

  constructor(
    private http: HttpClient,
  ) { }

  getSchedule(include_past: boolean) {
    return this.http.get(constants.IAPI_ENDPOINT + '/schedule?include_past=' + String(include_past), this.httpOptionsAuth);
  }

  postSchedule(event: any) {
    return this.http.post(constants.IAPI_ENDPOINT + '/schedule', JSON.stringify(event), this.httpOptionsAuth);
  }

  updateSchedule(id: string, event: any) {
    return this.http.put(constants.IAPI_ENDPOINT + '/schedule?schedule_id=' + id, JSON.stringify(event), this.httpOptionsAuth);
  }

  deleteSchedule(id: string) {
    return this.http.delete(constants.IAPI_ENDPOINT + '/schedule?schedule_id=' + id, this.httpOptionsAuth);
  }
}
